// profile/UpcomingEvents.jsx
import React from 'react';
import axios from 'axios';
import EventList from '../EventList';
import useCachedFetch from './hooks/useCachedFetch';
import { useTranslation } from 'react-i18next';

const UpcomingEvents = ({ user, isOwner }) => {

  const { data, loading, error, refetch } = useCachedFetch(
    `upcoming:${user?.id}`,
    async (signal) => {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/users/${user.id}/events/upcoming`, { signal });
      return res.data;
    },
    { enabled: !!user?.id, ttlMs: 60_000 }
  );

  const events = Array.isArray(data) ? data : [];
  const { t } = useTranslation('profile');

  if (loading) return <div>{t('loading')}</div>;
  if (error) return <div>{t('loadFailed')}<button onClick={refetch}>{t('retry')}</button></div>;
  if (!events.length) {
    return <div>{t('noEvents')}</div>;
  }

  return (
    <div>
      <EventList events={events} isOwner={isOwner} userId={user?.id} profileRole={user?.role} allowEdit={true} />
    </div>
  );
};

export default UpcomingEvents;
